const texteditor = require("../../../../components/texteditor/texteditor");

export function start(detail) {

  texteditorBody[detail.id].start(detail);

  detail.html = texteditorBody[detail.id];
  texteditor.start(detail);
}

const texteditorBody = {
  textEditorTest: {
    title: "Note",
    des: "Enter the note",
    bodyHtml: "",

    primary: {
      text: "Save",
      class: "button primary",
      dataDetail: "",
    },

    secondary: {
      text: "Close",
      class: "button secondary  button-plain",
      dataDetail: "",
    },

    tertiary: {
      text: "",
      class: "button secondary  button-plain",
      dataDetail: "",
    },

    textarea: {
      label: "",
      placeholder: "Write your notes here...",
    },

    start: function (detail) {
      this.secondary.dataDetail = `data-detail='{"click": [ {"dest":"ripple" }, {"dest":"texteditor", "act":"hide"} ]}'`;
      this.primary.dataDetail = `data-detail='{"click": [ {"dest":"ripple" }, {"dest":"warehousepurchase","elem":"fullcont" ,"act":"valueToInput", "lineId":"${detail.lineId}"},
      {"dest":"texteditor", "act":"hide"} ]}'`;
    },
  },
};
